import { StoreProps } from '@interfaces/StoreState'
import { getQueryParams, isGodMode } from '@utils/helpers'
import * as React from 'react'
import { useSelector } from 'react-redux'
import styled from 'styled-components'

export const InvisibleTextStyle = styled.div`
  opacity: 0.3;
  font-size: ${({ theme }) => theme.fontSize.xxxs};
  filter: alpha(opacity=20);
`

const InvisibleText: React.FC<{ children: any }> = ({ children }) => {
  const isAdmin = useSelector(({ session }: StoreProps) => session.isAdmin)
  const showInvisible = getQueryParams('showInvisible') === '1' || isGodMode(isAdmin)
  return showInvisible ? <InvisibleTextStyle>{children}</InvisibleTextStyle> : null
}

export default InvisibleText
